import { QuickLogHost } from "./components/actividad/QuickLog";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, RequireAuth } from "./lib/auth";
import { CrmShell } from "./components/crm/Shell";
import Login from "./pages/Login";
import Inicio from "./pages/Inicio";
import Deal from "./pages/Deal";
import Wizard from "./pages/Wizard";
import Tareas from "./pages/Tareas";
import Comisiones from "./pages/Comisiones";
import { PortalShell } from "./components/portal/PortalShell";
import PortalInicio from "./pages/portal/PortalInicio";
import PortalDeal from "./pages/portal/PortalDeal";
import PortalReferir from "./pages/portal/PortalReferir";
import PortalComisiones from "./pages/portal/PortalComisiones";
import PortalGuia from "./pages/portal/PortalGuia";
import PortalCobro from "./pages/portal/PortalCobro";
import PortalCotizar from "./pages/portal/PortalCotizar";
import PortalPerfil from "./pages/portal/PortalPerfil";
import Manual from "./pages/Manual";
import PortalPrograma from "./pages/portal/PortalPrograma";
import PortalCaptacion from "./pages/portal/PortalCaptacion";
import Asistente from "./pages/Asistente";
import RefPerfil from "./pages/RefPerfil";
import { OriginacionHub, CaptacionHub, CarteraHub, RiesgoHub, ReportesHub, SociosHub, AdminHub, ClientesHub, DemandaHub, ActividadHub } from "./pages/Hubs";
import { REDIRECTS } from "./lib/nav";
import Ficha360 from "./components/directorio/Ficha360";
import SolicitudPublica from "./pages/SolicitudPublica";
import AltaRef from "./pages/AltaRef";
import PortalLiga from "./pages/portal/PortalLiga";

const Redirect = ({ to }) => {
  const loc = useLocation();
  const tab = new URLSearchParams(loc.search).get("tab");
  if (to === "/socios/comisiones" && ["eval", "refs", "evaluacion", "faltas"].includes(tab)) return <Navigate to="/socios/referenciadores" replace />;
  return <Navigate to={{ pathname: to, search: tab && to === "/admin/configuracion" ? `?tab=${tab}` : loc.search }} replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <QuickLogHost />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/solicitud/:linea" element={<SolicitudPublica />} />
          <Route path="/alta-referenciador" element={<AltaRef />} />
          <Route path="/ref" element={<AltaRef />} />
          <Route element={<RequireAuth><CrmShell /></RequireAuth>}>
            <Route path="/" element={<Inicio />} />
            <Route path="/originacion/:tab?" element={<OriginacionHub />} />
            <Route path="/cartera/:tab?" element={<CarteraHub />} />
            <Route path="/captacion/:tab?" element={<CaptacionHub />} />
            <Route path="/riesgo/:tab?" element={<RiesgoHub />} />
            <Route path="/reportes-fondeo/:tab?" element={<ReportesHub />} />
            <Route path="/clientes/ficha/:id" element={<Ficha360 />} />
            <Route path="/clientes/:tab?" element={<ClientesHub />} />
            <Route path="/demanda/:tab?" element={<DemandaHub />} />
            <Route path="/actividad/:tab?" element={<ActividadHub />} />
            <Route path="/agenda" element={<Navigate to="/actividad/agenda" replace />} />
            <Route path="/socios/:tab?" element={<SociosHub />} />
            <Route path="/admin/:tab?" element={<AdminHub />} />
            <Route path="/deals/:id" element={<Deal />} />
            <Route path="/expedientes/:id" element={<Wizard />} />
            <Route path="/referenciadores/:id" element={<RefPerfil />} />
            <Route path="/tareas" element={<Tareas />} />
            <Route path="/comisiones/provisional" element={<RequireAuth perm={["comisiones.ver", "comisiones.gestionar"]}><Comisiones /></RequireAuth>} />
            <Route path="/manual" element={<Manual />} />
            <Route path="/asistente" element={<Asistente />} />
            {Object.entries(REDIRECTS).map(([from, to]) => <Route key={from} path={from} element={<Redirect to={to} />} />)}
          </Route>
          <Route path="/portal" element={<RequireAuth portal><PortalShell /></RequireAuth>}>
            <Route index element={<PortalInicio />} />
            <Route path="deals/:id" element={<PortalDeal />} />
            <Route path="referir" element={<PortalReferir />} />
            <Route path="comisiones" element={<PortalPrograma />} />
            <Route path="captacion" element={<PortalCaptacion />} />
            <Route path="comisiones/provisional" element={<PortalComisiones />} />
            <Route path="guia" element={<PortalGuia />} />
            <Route path="cobro" element={<PortalCobro />} />
            <Route path="cotizar" element={<PortalCotizar />} />
            <Route path="perfil" element={<PortalPerfil />} />
            <Route path="mi-liga" element={<PortalLiga />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
